import { cn } from "@/lib/utils";

interface FilterTab {
  id: string;
  label: string;
  active?: boolean;
  primary?: boolean;
}

interface FilterTabsProps {
  tabs: FilterTab[];
  onTabChange: (id: string) => void;
  activeTab: string;
}

export function FilterTabs({ tabs, onTabChange, activeTab }: FilterTabsProps) {
  return (
    <div className="inline-flex items-center gap-1 bg-muted rounded-full p-1" style={{ marginTop: "-4px" }}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            "px-[0.875rem] py-0 h-[35px] text-[0.8125rem] rounded-full transition-all duration-200 inline-flex items-center",
            activeTab === tab.id
              ? "bg-primary text-primary-foreground shadow-sm font-semibold"
              : "text-muted-foreground hover:text-foreground font-medium"
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}


